import { API_BASE as API, authHeaders } from "./api";

// Server copy of the homepage greeting rotation (GET/PUT
// /users/me/greeting-rotation) — what lets the no-repeat rules in
// src/components/home/discoveryGreetings.js hold across every device an
// account signs in on. Always optional: the browser keeps its own copy, so a
// slow, failing or not-yet-deployed endpoint only ever means "use the local
// one".
const PATH = "/users/me/greeting-rotation";
const FETCH_TIMEOUT_MS = 1500; // bounds how long the greeting can wait on it

export const greetingRotationQueryKey = (userId) => ["greeting-rotation", userId ?? null];

export async function fetchGreetingRotation(token) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);
  try {
    // no-store: a cached (stale) deck would deal a greeting the account has
    // already had — the whole point of syncing it. The endpoint says the
    // same, this is the belt to its braces.
    const res = await fetch(`${API}${PATH}`, { headers: authHeaders(token), signal: controller.signal, cache: "no-store" });
    if (!res.ok) throw new Error(res.statusText || `HTTP ${res.status}`);
    return await res.json(); // the stored rotation, or null if none yet
  } finally {
    clearTimeout(timer);
  }
}

// Best effort — the local copy already holds this state if it doesn't land.
export function saveGreetingRotation(token, rotation) {
  return fetch(`${API}${PATH}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeaders(token) },
    body: JSON.stringify(rotation),
    keepalive: true,
  }).catch(() => {});
}
